import toast from 'react-hot-toast';
import type { ApiError } from '@/types/api';

/** Ошибка запроса после интерцептора API: исходная ошибка axios и разобранный ответ сервера */
type RejectedRequest = { apiError?: ApiError };

const apiErrorOf = (error: unknown): ApiError | undefined =>
  error && typeof error === 'object' ? (error as RejectedRequest).apiError : undefined;

/**
 * Текст ошибки для пользователя: сообщение сервера (его разбирает интерцептор из всех форматов ответа),
 * а для ошибок не из API — запасной текст, чтобы не показывать внутренние сообщения кода.
 */
export function getErrorMessage(error: unknown, fallback: string): string {
  return apiErrorOf(error)?.message || fallback;
}

/**
 * Показывает ошибку один раз. Интерцептор API уже выводит тост с текстом сервера для каждой
 * неудачной операции; обработчики, показывавшие ещё и свой тост, давали два сообщения на одну
 * ошибку — второе часто общее «Ошибка при …» вместо причины.
 * `id` — тост загрузки, который нужно заменить сообщением об ошибке или убрать.
 */
export function notifyError(error: unknown, fallback: string, options?: { id?: string }): void {
  if (apiErrorOf(error)?.shown) {
    if (options?.id) toast.dismiss(options.id);
    return;
  }
  toast.error(getErrorMessage(error, fallback), options);
}
